import Navbar from "./Navbar.jsx";
import Hero from "./Hero.jsx";
import Traction from "./Traction.jsx";
import JourneyTimeline from "./JourneyTimeline.jsx";
import CarLoanPromo from "./CarLoanPromo.jsx";
import WhyNotJust from "./WhyNotJust.jsx";
import CTA from "./CTA.jsx";
import FAQ from "./FAQ.jsx";

/* ─────────────────────────────────────────────────────────────
   Plan2BenefitCarVersion — root of the Car Plan homepage.

   "The Spec Sheet": quiet, numbers-led, light theme. One
   illustrated moment only — the key handover in CTA — everywhere
   else stays plain typography and real figures.

   Section order: Hero → Proof → How it works → Car loan apply → Why us →
   CTA → FAQ.
   FAQ is deliberately last, right above the Footer that App.jsx
   renders globally on every route.

   This only imports three small, generic, presentational
   primitives from components/Plan2Benefit/ (Reveal,
   SectionHeading, CountUp) plus the shared handleOpenApp utility
   — none of which carry car-page business content, so nothing
   else on the site is touched by this page.

   JourneyTimeline is the chosen, final treatment of the
   "Everything you need. One Car Plan." step content — picked after
   an A/B/C comparison against HowItWorks and JourneyStory, both
   since deleted.
───────────────────────────────────────────────────────────── */
export default function Plan2BenefitCarVersion() {
  return (
    <div className="bg-white font-montserrat text-[#0d0828]">
      <Navbar />
      <Hero />
      <Traction />
      <JourneyTimeline />
      <CarLoanPromo />
      <WhyNotJust />
      <CTA />
      <FAQ />
    </div>
  );
}
